export const GIFT_CARD_ORDERS = {
  GET_ALL_USER_GIFT_CARD_ORDERS: 'GET_ALL_USER_GIFT_CARD_ORDERS',
}
